import React, { useState, useEffect } from "react";
import { Table, Button, Space, Modal } from "antd"; // Import Table, Button, Space, Modal from Ant Design
import { DomainApi } from "../../services/DomainApi";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../contexts/AxiosProvider";
import { useSnackbar } from "notistack";

const { Column } = Table;

// DateConverter function
export const DateConverter = (dateString) => {
  const d = new Date(dateString);
  return d.toDateString();
};

export default function DomainTable() {
  const axios = useAxios();
  const [domainData, setDomainData] = useState({
    domainList: [],
    totalDomains: 0,
  });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [approveModalVisible, setApproveModalVisible] = useState(false);
  const [rejectModalVisible, setRejectModalVisible] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);

  useEffect(() => {
    fetchAllDomains();
  }, [page]);

  const fetchAllDomains = async () => {
    try {
      setLoading(true);
      const data = {
        user_id: location.state.userId,
        search: false,
        searchParam: "",
        pageNumber: page,
        pageSize: rowsPerPage,
        status: "pending",
      };
      const response = await DomainApi.getAllDomains(axios, data);
      if (response.status === 200) {
        setDomainData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (pageNumber) => {
    setPage(pageNumber);
  };

  const handleApprove = async () => {
    try {
      setLoading(true);
      const data = {
        domain_id: selectedDomain.domain_id,
        status: "approved",
      };
      const response = await DomainApi.domainStatusChanged(axios, data);
      if (response.status === 200) {
        enqueueSnackbar("Function approved successfully !!", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        if (domainData.domainList.length === 1 && page > 1) {
          setPage((prevPage) => prevPage - 1);
        }
        fetchAllDomains();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
      setApproveModalVisible(false);
    }
  };

  const handleReject = async () => {
    try {
      setLoading(true);
      const data = {
        domain_id: selectedDomain.domain_id,
        status: "rejected",
      };
      const response = await DomainApi.domainStatusChanged(axios, data);
      if (response.status === 200) {
        enqueueSnackbar("Function rejected successfully !!", {
          variant: "success",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        if (domainData.domainList.length === 1 && page > 1) {
          setPage((prevPage) => prevPage - 1);
        }
        fetchAllDomains();
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setLoading(false);
      setRejectModalVisible(false);
    }
  };

  const handleApproveModal = (record) => {
    setSelectedDomain(record);
    setApproveModalVisible(true);
  };

  const handleRejectModal = (record) => {
    setSelectedDomain(record);
    setRejectModalVisible(true);
  };

  return (
    <>
      <Table
        dataSource={domainData.domainList}
        pagination={{
          total: domainData.totalDomains,
          pageSize: rowsPerPage,
          current: page,
          onChange: handleChangePage,
        }}
      >
        {/* <Column title="Client Name" dataIndex="client_name" key="client_name" /> */}
        <Column title="Function Name" dataIndex="domain_name" key="domain_name" />
        <Column title="Created By" dataIndex="created_by" key="created_by" />
        <Column
          title="Created On"
          dataIndex="creation_date"
          key="creation_date"
          render={(creation_date) => DateConverter(creation_date)}
        />
        <Column
          title="Action"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <Button type="primary" onClick={() => handleApproveModal(record)}>
                Approve
              </Button>
              <Button
                type="primary"
                danger
                onClick={() => handleRejectModal(record)}
              >
                Reject
              </Button>
            </Space>
          )}
        />
      </Table>

      {/* Approve Modal */}
      <Modal
        title="Approve Function"
        visible={approveModalVisible}
        onOk={handleApprove}
        onCancel={() => setApproveModalVisible(false)}
      >
        <p>
          Are you sure you want to approve the Function "
          {selectedDomain?.domain_name}"?
        </p>
      </Modal>

      {/* Reject Modal */}
      <Modal
        title="Reject Function"
        visible={rejectModalVisible}
        onOk={handleReject}
        onCancel={() => setRejectModalVisible(false)}
      >
        <p>
          Are you sure you want to reject the Function "
          {selectedDomain?.domain_name}"?
        </p>
      </Modal>
    </>
  );
}
